import { render, staticRenderFns } from "./FormProduct.vue?vue&type=template&id=1cf79c5a&scoped=true&"
import script from "./FormProduct.vue?vue&type=script&lang=js&"
export * from "./FormProduct.vue?vue&type=script&lang=js&"
import style0 from "./FormProduct.vue?vue&type=style&index=0&id=1cf79c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf79c5a",
  null
  
)

export default component.exports